import { ColumnDef } from '@3ddv/software-division-components/backoffice/table';
import { gsActionsColumn } from '../../shared/ui/table/gs-table.columns';
import { ServiceCharge } from './models/service-charge.model';

export function buildServiceChargeColumns(
  getDescription: (charge: ServiceCharge) => string,
  onEdit: (charge: ServiceCharge) => void,
  onDelete: (charge: ServiceCharge) => void,
  canEdit = true
): ColumnDef<ServiceCharge>[] {
  const idColumn: ColumnDef<ServiceCharge> = {
    id: 'id',
    header: 'ID',
    accessorFn: charge => charge.id,
  };

  const nameColumn: ColumnDef<ServiceCharge> = {
    id: 'name',
    header: 'Name',
    accessorFn: charge => charge.name,
  };

  const descriptionColumn: ColumnDef<ServiceCharge> = {
    id: 'description',
    header: 'Description',
    accessorFn: charge => getDescription(charge),
  };

  const actionsColumn = gsActionsColumn<ServiceCharge>({
    actions: [
      {
        id: 'edit',
        label: 'Edit',
        dataCy: charge => `service-charge-edit-button-${charge.id}`,
      },
      {
        id: 'delete',
        label: 'Delete',
        destructive: true,
        dataCy: charge => `service-charge-delete-button-${charge.id}`,
      },
    ],
    onSelect: (actionId, charge) => {
      if (actionId === 'edit') {
        onEdit(charge);
      } else if (actionId === 'delete') {
        onDelete(charge);
      }
    },
    rowDataCy: charge => `service-charge-row-${charge.id}`,
  });

  return [
    idColumn,
    nameColumn,
    descriptionColumn,
    ...(canEdit ? [actionsColumn] : []),
  ];
}
